import React from 'react';

export default function DetailsTable({ details, isLoading }) {
  const rowsPerColumn = 3;
  const columns = [];

  for (let i = 0; i < details.length; i += rowsPerColumn) {
    columns.push(details.slice(i, i + rowsPerColumn));
  }

  return (
    <div className="flex flex-wrap gap-x-[3.6vw] gap-y-4 sm:gap-y-12">
      {columns.map((column, colIdx) => (
        <div key={colIdx} className="grid grid-cols-[30%_1fr] gap-x-4 gap-y-4 w-full sm:w-auto sm:grid-cols-[max-content,max-content] sm:gap-x-12">
          {column.map((detail, i) => (
            <React.Fragment key={i}>
              <div className="text-[11px] sm:text-[13px]/[1.2] text-[#A5A5A5] font-medium">
                {detail.label}
              </div>
              <div className="text-[11px] sm:text-[13px]/[1.2] sm:max-w-[34ch] sm:truncate">
                {isLoading ? (
                  <div className="animate-pulse bg-[#F2F2F2] rounded-full w-32 h-3 mt-0.5 inline-block"></div>
                ) : (
                  detail.value || detail.none
                )}
              </div>
            </React.Fragment>
          ))}
        </div>
      ))}
    </div>
  );
}
